import { invalidPublicInterestCategories } from 'src/enums/financial-statement-audit';
import * as Yup from 'yup';
import { AuditingEntity, FinancialStatementAudit, Subject } from '@models';
import {
  FinancialStatementAuditType,
  PublicInterestEntityCategory,
} from '@enums';

export function useValidationSchema() {
  return Yup.object<FinancialStatementAudit>().shape({
    auditingEntities: Yup.array<AuditingEntity>().nullable().min(1).required(),
    auditedUnit: Yup.mixed<Subject>().nullable().required(),
    auditedUnitAccountingEndDate: Yup.string().nullable().required(),
    auditingEntityAccountingEndDate: Yup.string().nullable().required(),
    type: Yup.mixed<FinancialStatementAuditType>().required(),
    auditStartYear: Yup.number()
      .nullable()
      .when(['publicInterest', 'tradingCompany'], {
        is: (publicInterest, tradingCompany) =>
          !!publicInterest || !!tradingCompany,
        then: Yup.number()
          .min(1990, 'Rok musí byť väčší alebo rovný 1990')
          .max(2100, 'Rok musí byť menší alebo rovný 2100')
          .nullable()
          .required(),
      }),
    subjectAuditProfits: Yup.object()
      .nullable()
      .when(['publicInterest'], {
        is: (publicInterest) => !!publicInterest,
        then: Yup.object().shape({
          statutoryAudit: Yup.number().nullable().required(),
          nonAuditServicesB: Yup.number().nullable().required(),
          nonAuditServicesC: Yup.number().nullable().required(),
        }),
      }),
    tradingCompanyCategory: Yup.string()
      .when('tradingCompany', {
        is: true,
        then: Yup.string().required().nullable(),
      })
      .nullable(),
    category: Yup.mixed<PublicInterestEntityCategory>()
      .when('publicInterest', {
        is: true,
        then: Yup.string()
          .test(
            'invalid-category',
            'Neplatná kategória subjektu verejného záujmu',
            (value) =>
              !invalidPublicInterestCategories.includes(
                value as PublicInterestEntityCategory
              )
          )
          .required(),
      })
      .nullable(),
  }) as Yup.Schema<FinancialStatementAudit>;
}
